module.exports = __webpack_public_path__ + "202408221624/img/9.7401f796.png";